import React, { useEffect } from 'react'
import NavbarTop from './../components/global/NavbarTop';

import CaseStudiesPublicContent from '../components/CaseStudies/CaseStudiesPublicContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from './../redux/language/selector';

const CaseStudiesPublic = () => {

  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('case-studies-public-page.case-studies-public-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[language])

  return (
    <>
        <NavbarTop/>
        <CaseStudiesPublicContent/>  
    </>
  )
}

export default CaseStudiesPublic